import axios from 'axios'

// 创建一个axios实例
const simpleInstance = axios.create({
    timeout: 300000,
})

simpleInstance.interceptors.response.use(
    res => {
        return res;
    },
    err => {
        if (err.response) {
            const errCode = err.response.status;
            if (errCode === 400) {
                console.log("400!!!")
            }
        }
        return Promise.reject(err);
    }
);

export default simpleInstance;